import { render } from "./FormSubmitMessage.vue?vue&type=template&id=2ed89e6d"
import script from "./FormSubmitMessage.vue?vue&type=script&lang=js"
export * from "./FormSubmitMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/Shared/FormSubmitMessage/FormSubmitMessage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ed89e6d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ed89e6d', __exports__)) {
    api.reload('2ed89e6d', __exports__)
  }
  
  module.hot.accept("./FormSubmitMessage.vue?vue&type=template&id=2ed89e6d", () => {
    api.rerender('2ed89e6d', render)
  })

}


export default __exports__